export default __webpack_public_path__ + "static/media/1.3865bd70.png";